import React from 'react';
import NotSupportedImg from '@assets/icons/AssetPlaceholder/NotSupportedPlaceHolder-v2.png';
import AudioPlaceHolder from '@assets/icons/AssetPlaceholder/AudioPlaceHolder-v2.png';
import VideoPlaceHolder from '@assets/icons/AssetPlaceholder/VideoPlaceHolder-v2.png';
import DocumentPlaceHolder from '@assets/icons/AssetPlaceholder/DocumentPlaceHolder-v2.png';
import {
  AssetPlaceholderAudiofileIcon,
  AssetPlaceholderPdffileIcon,
  AssetPlaceholderUnsupportedIcon,
  AssetPlaceholderVideofileIcon
} from '@icons';

export function previewThumbnailsByType(
  type: string,
  size?: number,
  format?: 'svg' | 'img'
) {
  switch (type) {
    case 'audio':
      return format === 'svg' ? (
        <AssetPlaceholderAudiofileIcon width={size} height={size} />
      ) : (
        AudioPlaceHolder
      );
    case 'video':
      return format === 'svg' ? (
        <AssetPlaceholderVideofileIcon width={size} height={size} />
      ) : (
        VideoPlaceHolder
      );
    case 'raster_image':
    case 'camera_raw_image':
    case 'vector_image':
    case 'document':
    case 'presentation':
    case 'spreadsheet':
      return format === 'svg' ? (
        <AssetPlaceholderPdffileIcon width={size} height={size} />
      ) : (
        DocumentPlaceHolder
      );
    default:
      return format === 'svg' ? (
        <AssetPlaceholderUnsupportedIcon width={size} height={size} />
      ) : (
        NotSupportedImg
      );
  }
}

export function assetPreviewThumbnails({
  url,
  status,
  type,
  size = 40,
  format = 'svg',
  showPendingPlaceholder = false
}: {
  url: string | null | undefined;
  status: string;
  type: string;
  size?: number;
  format?: 'svg' | 'img';
  showPendingPlaceholder?: boolean;
}): string {
  if (showPendingPlaceholder && status === 'pending')
    return previewThumbnailsByType(type, size, format);

  if (status === 'pending') return 'pending';

  if (status === 'ready') {
    return url || previewThumbnailsByType(type, size, format);
  }
  return previewThumbnailsByType(type, size, format);
}
